module.exports = (__webpack_require__(0))(78);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/body/FrontPageView.js from dll-reference girder_lib
// module id = 137
// module chunks = 0